import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../types'
const defaultOptions = {} as const
export type VehicleDataFragmentFragment = {
  deviceID: string
  fleetModels: string
  licensePlate: string
  active: boolean
  vinNO: string
  driverID: string
  driver: string
  fleetName: string
  ID: string
  status: string
  tags?: Array<{ field?: string | null; value?: string | null }> | null
  properties?: Array<{ field?: string | null; value?: string | null }> | null
}

export type VehiclePositionFragmentFragment = {
  protocol: string
  imei: string
  status: string
  serverTime: string
  deviceTime: string
  positioningTime: string
  latitude: number
  longitude: number
  altitude: number
  ignition: boolean
  movement: boolean
  speed: number
  course: number
  properties?: Array<{ field?: string | null; value?: string | null }> | null
}

export type LastPositionTrimmedQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.LastPositionListTrimmedParam>
}>

export type LastPositionTrimmedQuery = {
  vehicles: {
    lastPositionListTrimmed: {
      positionData: Array<{
        ID: string
        status: string
        latitude: number
        longitude: number
        fleetName: string
        fleetType: string
        fleetModel: string
        vinNO: string
        Image: string
        battery: string
        manufacture: string
        licensePlate: string
        odometer: string
        speed: string
        transmission: string
        mode: string
        remark: string
        driverName?: string | null
      }>
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type LiveTrackingMapQueryVariables = Types.Exact<{
  pagination: Types.PaginationParam
}>

export type LiveTrackingMapQuery = {
  vehicles: {
    lastPositionList: {
      data: Array<{
        data?: {
          position: { latitude: number; longitude: number; status: string }
        } | null
      }>
    }
  }
}

export type ListAssetsQueryVariables = Types.Exact<{
  search: Types.Scalars['String']
  disableUserOrgFilter?: Types.InputMaybe<Types.Scalars['Boolean']>
  filterBy?: Types.InputMaybe<Types.LastPositionFilterType>
  pagination: Types.PaginationParam
  orgID?: Types.InputMaybe<Types.Scalars['String']>
  sortBy: Types.SortByVehicles
  sortOrder: Types.SortOrder
  fleetType?: Types.InputMaybe<Types.Scalars['String']>
}>

export type ListAssetsQuery = {
  vehicles: {
    listVehicles: {
      data: Array<{
        ID: string
        data?: {
          vehicle: {
            deviceID: string
            fleetName: string
            ID: string
            licensePlate: string
            status: string
            vinNO: string
            fleetTypeID?: string | null
            fleetType: string
            fleetModelsID: string
            driver: string
            driverID: string
            remark: string
            tenantID: string
            tenantName: string
            image: string
            distanceToday: string
            area: string
            properties?: Array<{
              field?: string | null
              value?: string | null
            }> | null
          }
          position: {
            imei: string
            sim: string
            latitude: number
            longitude: number
            status: string
            deviceTime: string
            positioningTime: string
            battery: number
            mcb: number
            mileage: number
          }
        } | null
      }>
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type ListAssetsForPropertiesQueryVariables = Types.Exact<{
  search: Types.Scalars['String']
  disableUserOrgFilter?: Types.InputMaybe<Types.Scalars['Boolean']>
  filterBy?: Types.InputMaybe<Types.LastPositionFilterType>
  pagination: Types.PaginationParam
  orgID?: Types.InputMaybe<Types.Scalars['String']>
  sortBy: Types.SortByVehicles
  sortOrder: Types.SortOrder
}>

export type ListAssetsForPropertiesQuery = {
  vehicles: {
    listVehicles: {
      data: Array<{
        ID: string
        data?: {
          vehicle: { fleetName: string; ID: string; image: string }
          position: {
            imei: string
            sim: string
            latitude: number
            longitude: number
            status: string
            deviceTime: string
            positioningTime: string
            battery: number
            mcb: number
            properties?: Array<{
              field?: string | null
              value?: string | null
            }> | null
          }
        } | null
      }>
    }
  }
}

export type LastPositionListQueryVariables = Types.Exact<{
  search: Types.Scalars['String']
  pagination: Types.PaginationParam
  filterBy?: Types.InputMaybe<Types.LastPositionFilterType>
  orgID?: Types.InputMaybe<Types.Scalars['String']>
}>

export type LastPositionListQuery = {
  vehicles: {
    lastPositionList: {
      data: Array<{
        ID: string
        data?: {
          vehicle: {
            fleetTypeID?: string | null
            fleetType: string
            fleetModelsID: string
            remark: string
            deviceID: string
            fleetModels: string
            licensePlate: string
            active: boolean
            vinNO: string
            driverID: string
            driver: string
            fleetName: string
            ID: string
            status: string
            tags?: Array<{
              field?: string | null
              value?: string | null
            }> | null
            properties?: Array<{
              field?: string | null
              value?: string | null
            }> | null
          }
          position: {
            protocol: string
            imei: string
            status: string
            serverTime: string
            deviceTime: string
            positioningTime: string
            latitude: number
            longitude: number
            altitude: number
            ignition: boolean
            movement: boolean
            speed: number
            course: number
            properties?: Array<{
              field?: string | null
              value?: string | null
            }> | null
          }
        } | null
      }>
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type LastPositionAssetOptionsQueryVariables = Types.Exact<{
  orgID?: Types.InputMaybe<Types.Scalars['String']>
}>

export type LastPositionAssetOptionsQuery = {
  vehicles: {
    lastPositionList: {
      data: Array<{ data?: { vehicle: { ID: string; vinNO: string } } | null }>
    }
  }
}

export type TripHistoryQueryVariables = Types.Exact<{
  ID: Types.Scalars['String']
  startDate: Types.Scalars['String']
  endDate: Types.Scalars['String']
}>

export type TripHistoryQuery = {
  vehicles: {
    tripHistory?: Array<{
      startTime: string
      distance: number
      duration: string
      endTime: string
      batteryData: Array<{
        no: number
        startCapacity: number
        endCapacity: number
        batteryConsumption: number
      }>
      positions: Array<{
        positioningTime: string
        latitude: number
        longitude: number
        course: number
      }>
    }> | null
  }
}

export type RouteOverviewQueryVariables = Types.Exact<{
  ID: Types.Scalars['String']
  startTime: Types.Scalars['String']
  endTime: Types.Scalars['String']
}>

export type RouteOverviewQuery = {
  vehicles: {
    routeOverview: {
      data: Array<{
        positioningTime: string
        deviceTime: string
        latitude: number
        longitude: number
        course: number
      }>
    }
  }
}

export type GenericPositionHistoryQueryVariables = Types.Exact<{
  ID: Types.Scalars['String']
  startDate: Types.Scalars['String']
  endDate: Types.Scalars['String']
}>

export type GenericPositionHistoryQuery = {
  vehicles: {
    positionHistory: {
      tenant: string
      vinNo: string
      licensePlate: string
      data: Array<{
        course: number
        latitude: number
        longitude: number
        positioningTime: string
        battery: number
        speed: number
        remarks: string
        event: string
        mileage: number
        ignition: boolean
        isBlackBox: boolean
        address: string
        properties?: Array<{
          field?: string | null
          value?: string | null
          label?: string | null
        }> | null
      }>
    }
  }
}

export type ProductivityListVehicleQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.LastPositionListParam>
}>

export type ProductivityListVehicleQuery = {
  vehicles: {
    listVehicles: {
      data: Array<{
        ID: string
        data?: { vehicle: { fleetName: string; ID: string } } | null
      }>
    }
  }
}

export type DetailVehicleQueryVariables = Types.Exact<{
  id: Types.Scalars['String']
}>

export type DetailVehicleQuery = {
  vehicles: {
    lastPosition: {
      ID: string
      data?: {
        position: {
          course: number
          status: string
          speed: number
          positioningTime: string
          latitude: number
          longitude: number
          ignition: boolean
          imei: string
          mileage: number
          properties?: Array<{
            field?: string | null
            value?: string | null
          }> | null
        }
        vehicle: {
          active: boolean
          deviceID: string
          deviceModel: string
          driver: string
          driverID: string
          fleetModels: string
          fleetTypeID?: string | null
          fleetType: string
          fleetModelsID: string
          fleetName: string
          ID: string
          remark: string
          licensePlate: string
          status: string
          vinNO: string
          tenantID: string
          properties?: Array<{
            field?: string | null
            value?: string | null
          }> | null
          tags?: Array<{ field?: string | null; value?: string | null }> | null
        }
      } | null
    }
  }
}

export type GetReportQueryVariables = Types.Exact<{
  filename: Types.Scalars['String']
}>

export type GetReportQuery = {
  vehicles: {
    getReport: Array<{
      startTime: string
      endTime: string
      startCoordinate: string
      endCoordinate: string
      duration: string
      distance: string
    }>
  }
}

export type ListReportQueryVariables = Types.Exact<{
  search: Types.Scalars['String']
  pagination: Types.PaginationParam
}>

export type ListReportQuery = {
  vehicles: {
    listReport: {
      data: Array<{
        ID: string
        date: string
        type: string
        fleetID: string
        fleetName: string
        status: string
        fileUrl: string
        requestedAt: string
      }>
      pagination?: {
        totalPage: number
        totalRecord: number
        next: number
        last: number
        current: number
        before: number
        first: number
        perPage: number
      } | null
    }
  }
}

export type AssetOptionsQueryVariables = Types.Exact<{
  search: Types.Scalars['String']
  filterByAssignment?: Types.InputMaybe<Types.VehicleFilterType>
  orgID?: Types.InputMaybe<Types.Scalars['String']>
  pagination?: Types.InputMaybe<Types.PaginationParam>
  sortBy?: Types.InputMaybe<Types.SortByVehicles>
  sortOrder?: Types.InputMaybe<Types.SortOrder>
}>

export type AssetOptionsQuery = {
  vehicles: {
    listVehicles: {
      data: Array<{
        ID: string
        data?: {
          vehicle: { fleetModels: string; fleetName: string; ID: string }
        } | null
      }>
    }
  }
}

export type AssetDeviceListOptionsQueryVariables = Types.Exact<{
  search: Types.Scalars['String']
  disableUserOrgFilter?: Types.InputMaybe<Types.Scalars['Boolean']>
  filterByAssignment?: Types.InputMaybe<Types.VehicleFilterType>
  orgID?: Types.InputMaybe<Types.Scalars['String']>
  pagination?: Types.InputMaybe<Types.PaginationParam>
}>

export type AssetDeviceListOptionsQuery = {
  vehicles: {
    listVehicles: {
      data: Array<{
        ID: string
        data?: {
          vehicle: { fleetName: string; ID: string; vinNO: string }
        } | null
      }>
    }
  }
}

export type ListChartOdometerQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.TravelParam>
  pagination?: Types.InputMaybe<Types.PaginationParam>
}>

export type ListChartOdometerQuery = {
  vehicles: {
    GetOdomoterRecords: {
      travelData: Array<{
        name?: string | null
        travelled?: number | null
        target?: number | null
        fleetType?: string | null
      }>
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type ListCycleRouteQueryVariables = Types.Exact<{
  id: Types.Scalars['String']
  date: Types.Scalars['String']
}>

export type ListCycleRouteQuery = {
  vehicles: {
    GetRouteList: {
      routeData: Array<{
        route: string
        startTime: string
        endTime: string
        distance: number
      }>
      fleetCycleSummary: Array<{
        ID: string
        fleetID: string
        poolGeofenceID: string
        departureTime: string
        startMileageKm: number
        firstRouteName: string
        firstStationGeofenceID: string
        firstStationArrivalTime: string
        firstStationMileageKm: number
        returnFromRouteName: string
        returnFromGeofenceID: string
        returnDepartureTime: string
        returnArrivalTime: string
        returnMileageKm: number
        startBatterySocPct?: number | null
        returnBatterySocPct?: number | null
        batteryUsageKwh?: number | null
        lastStationMileageKm: number
        trip11MileageKm?: number | null
        trip12MileageKm?: number | null
        trip1MileageKm?: number | null
        trip2MileageKm?: number | null
        trip21MileageKm?: number | null
        trip22MileageKm?: number | null
      }>
    }
  }
}

export type NightTimeAlertTotalQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type NightTimeAlertTotalQuery = {
  vehicles: { listNighttimeAlert: { count: number } }
}

export type ListNightTimeAlertQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type ListNightTimeAlertQuery = {
  vehicles: {
    listNighttimeAlert: {
      data?: Array<{
        startTime: string
        endTime: string
        duration: string
        distance: number
        batteryData: Array<{
          no: number
          startCapacity: number
          endCapacity: number
          batteryConsumption: number
        }>
        positions: Array<{
          course: number
          latitude: number
          longitude: number
          positioningTime: string
        }>
      }> | null
    }
  }
}

export type ExcessiveIdlingTotalQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type ExcessiveIdlingTotalQuery = {
  vehicles: { ListExcessiveIdling: { total: number } }
}

export type ListExcessiveIdlingQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type ListExcessiveIdlingQuery = {
  vehicles: {
    ListExcessiveIdling: {
      data: Array<{
        startTime: string
        endTime: string
        duration: number
        latitude: number
        longitude: number
      }>
    }
  }
}

export type TamperingTotalQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type TamperingTotalQuery = {
  vehicles: { ListTampering: { total: number } }
}

export type ListTamperingQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type ListTamperingQuery = {
  vehicles: {
    ListTampering: {
      data: Array<{ time: string; latitude: number; longitude: number }>
    }
  }
}

export type DashboardStatisticQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type DashboardStatisticQuery = {
  vehicles: {
    getDashboardStatictic: {
      duration: string
      avgSpeed: string
      topSpeed: string
      distance: string
    }
  }
}

export type DrivingScoreQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type DrivingScoreQuery = {
  vehicles: {
    GetDrivingScore: {
      score: number
      count: number
      mean: number
      median: number
      overSpeedcount: number
      harshBreakingcount: number
      crashDetectioncount: number
    }
  }
}

export type DrivingScoreListQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type DrivingScoreListQuery = {
  vehicles: {
    GetDrivingScore: {
      score: number
      count: number
      mean: number
      median: number
      overSpeedcount: number
      harshBreakingcount: number
      crashDetectioncount: number
      overSpeed: Array<{
        time: string
        value: string
        latitude: number
        longitude: number
        speed: number
      }>
      harshBreaking: Array<{
        time: string
        value: string
        latitude: number
        longitude: number
        speed: number
      }>
      crashDetection: Array<{
        time: string
        value: string
        latitude: number
        longitude: number
        speed: number
      }>
    }
  }
}

export type GeofenceAlertQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.ListParam>
  startDate?: Types.InputMaybe<Types.Scalars['String']>
  endDate?: Types.InputMaybe<Types.Scalars['String']>
  fleetID?: Types.InputMaybe<Types.Scalars['String']>
}>

export type GeofenceAlertQuery = {
  geofences: {
    fetchGeofenceEvents: {
      data: Array<{
        ID: string
        time: string
        geofenceId: string
        orgId: string
        fleetId: string
        event: string
        fleetName: string
        coordinate: Array<number>
      }>
    }
  }
}

export type OverSpeedAlertQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.ListParam>
  startDate?: Types.InputMaybe<Types.Scalars['String']>
  endDate?: Types.InputMaybe<Types.Scalars['String']>
  fleetid?: Types.InputMaybe<Types.Scalars['String']>
  event?: Types.InputMaybe<Types.EventType>
}>

export type OverSpeedAlertQuery = {
  geofences: {
    fetchNotificationsEvents: {
      data: Array<{
        ID: string
        time: string
        geofenceId: string
        orgId: string
        fleetId: string
        event: string
        fleetName: string
        coordinate: Array<number>
      }>
    }
  }
}

export type StopHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type StopHistoryQuery = {
  vehicles: {
    stopHistory?: Array<{
      startTime: string
      endTime: string
      duration: string
      distance: number
      avgSpeed: number
      topSpeed: number
      driver: string
      batteryData: Array<{
        no: number
        startCapacity: number
        endCapacity: number
        batteryConsumption: number
      }>
      positions: Array<{
        course: number
        latitude: number
        longitude: number
        positioningTime: string
      }>
    }> | null
  }
}

export type EngineHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type EngineHistoryQuery = {
  vehicles: {
    ignitionHistory?: Array<{
      startTime: string
      endTime: string
      duration: string
      distance: number
      avgSpeed: number
      topSpeed: number
      driver: string
      ignition: boolean
      batteryData: Array<{
        no: number
        startCapacity: number
        endCapacity: number
        batteryConsumption: number
      }>
      positions: Array<{
        course: number
        latitude: number
        longitude: number
        positioningTime: string
      }>
    }> | null
  }
}

export type EventHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type EventHistoryQuery = {
  vehicles: {
    listTHREvent: Array<{
      driver: string
      badge: string
      time: string
      event: string
      ignition?: boolean | null
      speed: number
      adress: string
    }>
  }
}

export type GeofenceThrHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type GeofenceThrHistoryQuery = {
  geofences: {
    fetchTHRgeofenceEvents: Array<{
      driver: string
      badge: string
      time: string
      dir: string
      category: string
      name: string
      address: string
    }>
  }
}

export type RashDrivingHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type RashDrivingHistoryQuery = {
  vehicles: {
    listTHRrashDriving: Array<{
      driver: string
      badge: string
      time: string
      event: string
      ignition?: boolean | null
      speed: number
      adress: string
    }>
  }
}

export type ReverseHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type ReverseHistoryQuery = {
  vehicles: {
    listTHRreverse: Array<{
      driver: string
      badge: string
      startTime: string
      endTime: string
      avgSpeed: number
      topSpeed: number
      distance: number
      duration: string
      adress: string
      area: string
      latitude: number
      longitude: number
    }>
  }
}

export type DetailHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
  pagination?: Types.InputMaybe<Types.PaginationParam>
}>

export type DetailHistoryQuery = {
  vehicles: {
    listTHRDetail: {
      data: Array<{
        driver: string
        badge: string
        rfid: string
        ignition: boolean
        time: string
        speed: number
        speedLimit: number
        adress: string
        place: string
        latitude: number
        longitude: number
        temperature: number
      }>
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type SpeedingHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type SpeedingHistoryQuery = {
  vehicles: {
    listTHRSpeed: Array<{
      driver: string
      badge: string
      time: string
      duration: string
      topSpeed: number
      speedLimit: number
      distance: number
      latitude: number
      longitude: number
      adress: string
      area: string
    }>
  }
}

export type DrivingHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type DrivingHistoryQuery = {
  vehicles: {
    listTHRDriving: Array<{
      driver: string
      badge: string
      rfid: string
      startTime: string
      endTime: string
      avgSpeed: number
      topSpeed: number
      distance: number
      duration: string
      adressStart: string
      addressEnd: string
    }>
  }
}

export type IdleHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
}>

export type IdleHistoryQuery = {
  vehicles: {
    idleHistory?: Array<{
      startTime: string
      endTime: string
      duration: string
      distance: number
      avgSpeed: number
      topSpeed: number
      driver: string
      batteryData: Array<{
        no: number
        startCapacity: number
        endCapacity: number
        batteryConsumption: number
      }>
      positions: Array<{
        course: number
        latitude: number
        longitude: number
        positioningTime: string
      }>
    }> | null
  }
}

export type ListTimelineHistoryQueryVariables = Types.Exact<{
  param: Types.HistoryParam
}>

export type ListTimelineHistoryQuery = {
  vehicles: {
    GetTimeline: {
      data?: Array<{
        type: string
        startTime: string
        endTime: string
        address: string
        driver: string
        avgSpeed: string
        topSpeed: string
        distance: string
        duration: string
      }> | null
    }
  }
}

export type ReportListGroupQueryVariables = Types.Exact<{
  id: Types.Scalars['String']
}>

export type ReportListGroupQuery = {
  vehicles: {
    GetVehiclesReportListS3: {
      reportFileData: Array<{ url: string; filename: string }>
    }
  }
}

export type ListWebHookQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.ListParam>
  orgID: Types.Scalars['String']
}>

export type ListWebHookQuery = {
  geofences: {
    ListWebhookUrl: {
      data: Array<{ id: string; url: string; key: string }>
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type RequestReportMutationVariables = Types.Exact<{
  fleetID: Types.Scalars['String']
  type: Types.Scalars['String']
  date: Types.Scalars['String']
}>

export type RequestReportMutation = {
  vehicles: {
    requestReport: {
      status: string
      requestedAt: string
      ID: string
      type: string
      fleetID: string
      fileUrl: string
      date: string
    }
  }
}

export type ListVehicleModelsQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.ModelListParam>
}>

export type ListVehicleModelsQuery = {
  vehicles: {
    listVehicleModels: { data: Array<{ model: string; ID: string }> }
  }
}

export type ListVehicleTypesQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type ListVehicleTypesQuery = {
  vehicles: { listVehicleTypes: { data: Array<{ ID: string; name: string }> } }
}

export type IsNeedAccessRemarkQueryVariables = Types.Exact<{
  id: Types.Scalars['String']
  type: Types.AccessType
}>

export type IsNeedAccessRemarkQuery = {
  vehicles: { isNeedAccessRemark: boolean }
}

export type ListAccessHistoryQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.AccessHistoryParam>
}>

export type ListAccessHistoryQuery = {
  vehicles: {
    listAccessHistory: {
      lastUpdated?: string | null
      data?: Array<{
        vinNo?: string | null
        imei?: string | null
        user?: string | null
        remark?: string | null
        date?: string | null
        type?: string | null
      } | null> | null
      pagination?: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      } | null
    }
  }
}

export type GroupReportMonthQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
  pagination?: Types.InputMaybe<Types.PaginationParam>
}>

export type GroupReportMonthQuery = {
  vehicles: {
    GetGroupReport: {
      data: Array<{
        avgDistancePerDay: string
        avgDistancePerTrip: string
        avgDurationPerDay: string
        avgDurationPerTrip: string
        avgSpeed: string
        avgTripPerDay: string
        avgBatteryPerDay: string
        avgBatteryPerTrip: string
        distance: string
        duration: string
        topSpeed: string
        tripCount: string
        FleetName: string
        LicensePlate: string
        Status: string
        batteryConsumption: string
        firstTripStartTime: string
        lastTripEndTime: string
        vinNo: string
      }>
      pagination: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      }
    }
  }
}

export type GroupReportDetailQueryVariables = Types.Exact<{
  param?: Types.InputMaybe<Types.HistoryParam>
  pagination?: Types.InputMaybe<Types.PaginationParam>
}>

export type GroupReportDetailQuery = {
  vehicles: {
    GetGroupReportDetail: {
      data: Array<{
        FleetName: string
        LicensePlate: string
        startTime: string
        endTime: string
        batteryConsumption: string
        avgSpeed: number
        topSpeed: number
        duration: string
        distance: string
        vinNo: string
      }>
      pagination: {
        first: number
        before: number
        current: number
        next: number
        last: number
        perPage: number
        totalPage: number
        totalRecord: number
      }
    }
  }
}

export type GetPublicTrackingQueryVariables = Types.Exact<{
  id: Types.Scalars['String']
}>

export type GetPublicTrackingQuery = {
  vehicles: {
    GetPublicTracking: {
      ID: string
      data?: {
        vehicle: {
          ID: string
          active: boolean
          deviceID: string
          fleetModels: string
          fleetModelsID: string
          fleetName: string
          fleetType: string
          fleetTypeID?: string | null
          licensePlate: string
          status: string
          tenantID: string
          vinNO: string
          imei: string
          deviceModel: string
          deviceModelID: string
          image: string
          remark: string
          properties?: Array<{
            field?: string | null
            value?: string | null
          }> | null
          tags?: Array<{ field?: string | null; value?: string | null }> | null
        }
        position: {
          altitude: number
          course: number
          deviceTime: string
          ignition: boolean
          latitude: number
          longitude: number
          movement: boolean
          positioningTime: string
          serverTime: string
          speed: number
          imei: string
          status: string
          sim: string
          battery: number
          mcb: number
          address: string
          place: string
          remarks: string
          event: string
          mileage: number
          properties?: Array<{
            field?: string | null
            value?: string | null
          }> | null
        }
      } | null
    }
  }
}

export type CreatePublicTrackingMutationVariables = Types.Exact<{
  vin: Types.Scalars['String']
}>

export type CreatePublicTrackingMutation = {
  vehicles: {
    CreatePublicTracking: { id: string; success: boolean; message: string }
  }
}

export type CreateVehiclesAccessHistoryMutationVariables = Types.Exact<{
  id: Types.Scalars['String']
  remark: Types.Scalars['String']
  type: Types.AccessType
}>

export type CreateVehiclesAccessHistoryMutation = {
  vehicles: {
    createVehicleAccessHistory: {
      id: string
      message: string
      success: boolean
    }
  }
}

export type VehicleSingleUploadMutationVariables = Types.Exact<{
  in: Types.Scalars['Upload']
}>

export type VehicleSingleUploadMutation = {
  vehicles: {
    singleUpload: { success: boolean; message: string; name: string }
  }
}

export type CreateVehiclesMutationVariables = Types.Exact<{
  param: Types.VehicleParam
}>

export type CreateVehiclesMutation = {
  vehicles: { createVehicles: { message: string; success: boolean } }
}

export type UpdateVehiclesMutationVariables = Types.Exact<{
  id: Types.Scalars['String']
  param: Types.VehicleParam
}>

export type UpdateVehiclesMutation = {
  vehicles: { updateVehicles: { message: string; success: boolean } }
}

export type DeleteVehiclesMutationVariables = Types.Exact<{
  id: Types.Scalars['String']
}>

export type DeleteVehiclesMutation = {
  vehicles: { deleteVehicles: { message: string; success: boolean } }
}

export type AddVehicleToGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['String']
  orgid: Types.Scalars['String']
}>

export type AddVehicleToGroupMutation = {
  vehicles: { addVehicleToGroup: { message: string; success: boolean } }
}

export type BulkAddVehicleToGroupMutationVariables = Types.Exact<{
  ids: Types.Scalars['String']
  orgid: Types.Scalars['String']
}>

export type BulkAddVehicleToGroupMutation = {
  vehicles: { bulkAddVehicleToGroup: { message: string; success: boolean } }
}

export type CreateWebHookUrlMutationVariables = Types.Exact<{
  data: Types.WebhookUrlInput
  orgID: Types.Scalars['String']
}>

export type CreateWebHookUrlMutation = {
  geofences: {
    CreateWebhookURL: { success: boolean; message: string; id: string }
  }
}

export type EditWebHookUrlMutationVariables = Types.Exact<{
  data: Types.WebhookUrlInput
  id: Types.Scalars['String']
}>

export type EditWebHookUrlMutation = {
  geofences: {
    EditWebhookURL: { success: boolean; message: string; id: string }
  }
}

export type DeleteWebHookUrlMutationVariables = Types.Exact<{
  id: Types.Scalars['String']
}>

export type DeleteWebHookUrlMutation = {
  geofences: {
    DeleteWebhookURL: { success: boolean; message: string; id: string }
  }
}

export type UploadVehicleImageMutationVariables = Types.Exact<{
  in: Types.Scalars['Upload']
  id: Types.Scalars['String']
}>

export type UploadVehicleImageMutation = {
  vehicles: {
    UploadVehicleImage: { message: string; success: boolean; name: string }
  }
}

export type GetVehicleStatusSummaryQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GetVehicleStatusSummaryQuery = {
  vehicles: {
    GetVehicleStatusSummary: {
      lastUpdated: string
      vehicleStatusSummary: {
        totalUnits: number
        noRfidDriver: number
        unregisteredRfid: number
        noGpsData: number
      }
      engineStatus: { on: number; off: number; delay: number }
      inArea: { private: number; public: number }
      vehicleStatus: {
        driving: number
        stop: number
        idle: number
        delay: number
      }
    }
  }
}

export type GetBiReportsQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetBiReportsQuery = {
  vehicles: {
    GetBIReports: {
      reports: Array<{
        name: string
        reportUrl: string
        permissions: Array<string>
        url: string
      }>
    }
  }
}

export type AvailableKalistaMerchantQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type AvailableKalistaMerchantQuery = {
  vehicles: {
    AvailableKalistaMerchants: Array<{
      code: string
      label: string
      permission: string
    }>
  }
}

export type DetachGrabMutationVariables = Types.Exact<{
  vin: Types.Scalars['String']
}>

export type DetachGrabMutation = {
  grab: { detachGrab: { id: string; message: string; success: boolean } }
}

export type DetailVehicleDetachGrabQueryVariables = Types.Exact<{
  id: Types.Scalars['String']
}>

export type DetailVehicleDetachGrabQuery = {
  vehicles: { lastPosition: { data?: { canDetachGrab: boolean } | null } }
}

export const VehicleDataFragmentFragmentDoc = gql`
  fragment vehicleDataFragment on VehicleData {
    deviceID
    fleetModels
    tags {
      field
      value
    }
    licensePlate
    properties {
      field
      value
    }
    active
    vinNO
    driverID
    driver
    fleetName
    ID
    status
  }
`
export const VehiclePositionFragmentFragmentDoc = gql`
  fragment vehiclePositionFragment on PositionData {
    protocol
    imei
    status
    serverTime
    deviceTime
    positioningTime
    latitude
    longitude
    altitude
    ignition
    movement
    speed
    course
    properties {
      field
      value
    }
  }
`
export const LastPositionTrimmedDocument = gql`
  query lastPositionTrimmed($param: LastPositionListTrimmedParam) {
    vehicles {
      lastPositionListTrimmed(param: $param) {
        positionData {
          ID
          status
          latitude
          longitude
          fleetName
          fleetType
          fleetModel
          vinNO
          Image
          battery
          manufacture
          licensePlate
          odometer
          speed
          transmission
          mode
          remark
          driverName
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useLastPositionTrimmedQuery__
 *
 * To run a query within a React component, call `useLastPositionTrimmedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPositionTrimmedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPositionTrimmedQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useLastPositionTrimmedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LastPositionTrimmedQuery,
    LastPositionTrimmedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LastPositionTrimmedQuery,
    LastPositionTrimmedQueryVariables
  >(LastPositionTrimmedDocument, options)
}
export function useLastPositionTrimmedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LastPositionTrimmedQuery,
    LastPositionTrimmedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LastPositionTrimmedQuery,
    LastPositionTrimmedQueryVariables
  >(LastPositionTrimmedDocument, options)
}
export type LastPositionTrimmedQueryHookResult = ReturnType<
  typeof useLastPositionTrimmedQuery
>
export type LastPositionTrimmedLazyQueryHookResult = ReturnType<
  typeof useLastPositionTrimmedLazyQuery
>
export const LiveTrackingMapDocument = gql`
  query liveTrackingMap($pagination: PaginationParam!) {
    vehicles {
      lastPositionList(param: { pagination: $pagination }) {
        data {
          data {
            position {
              latitude
              longitude
              status
            }
          }
        }
      }
    }
  }
`

/**
 * __useLiveTrackingMapQuery__
 *
 * To run a query within a React component, call `useLiveTrackingMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveTrackingMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTrackingMapQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLiveTrackingMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    LiveTrackingMapQuery,
    LiveTrackingMapQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LiveTrackingMapQuery, LiveTrackingMapQueryVariables>(
    LiveTrackingMapDocument,
    options
  )
}
export function useLiveTrackingMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LiveTrackingMapQuery,
    LiveTrackingMapQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LiveTrackingMapQuery,
    LiveTrackingMapQueryVariables
  >(LiveTrackingMapDocument, options)
}
export type LiveTrackingMapQueryHookResult = ReturnType<
  typeof useLiveTrackingMapQuery
>
export type LiveTrackingMapLazyQueryHookResult = ReturnType<
  typeof useLiveTrackingMapLazyQuery
>
export const ListAssetsDocument = gql`
  query listAssets(
    $search: String!
    $disableUserOrgFilter: Boolean
    $filterBy: LastPositionFilterType
    $pagination: PaginationParam!
    $orgID: String
    $sortBy: SortByVehicles!
    $sortOrder: SortOrder!
    $fleetType: String
  ) {
    vehicles {
      listVehicles(
        param: {
          search: $search
          filterBy: $filterBy
          disableUserOrgFilter: $disableUserOrgFilter
          pagination: $pagination
          orgID: $orgID
          sortBy: $sortBy
          sortOrder: $sortOrder
          fleetType: $fleetType
        }
      ) {
        data {
          ID
          data {
            vehicle {
              deviceID
              fleetName
              ID
              licensePlate
              status
              vinNO
              fleetTypeID
              fleetType
              fleetModelsID
              driver
              driverID
              remark
              properties {
                field
                value
              }
              tenantID
              tenantName
              image
              distanceToday
              area
            }
            position {
              imei
              sim
              latitude
              longitude
              status
              deviceTime
              positioningTime
              battery
              mcb
              mileage
            }
          }
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useListAssetsQuery__
 *
 * To run a query within a React component, call `useListAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssetsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      disableUserOrgFilter: // value for 'disableUserOrgFilter'
 *      filterBy: // value for 'filterBy'
 *      pagination: // value for 'pagination'
 *      orgID: // value for 'orgID'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      fleetType: // value for 'fleetType'
 *   },
 * });
 */
export function useListAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListAssetsQuery,
    ListAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListAssetsQuery, ListAssetsQueryVariables>(
    ListAssetsDocument,
    options
  )
}
export function useListAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAssetsQuery,
    ListAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListAssetsQuery, ListAssetsQueryVariables>(
    ListAssetsDocument,
    options
  )
}
export type ListAssetsQueryHookResult = ReturnType<typeof useListAssetsQuery>
export type ListAssetsLazyQueryHookResult = ReturnType<
  typeof useListAssetsLazyQuery
>
export const ListAssetsForPropertiesDocument = gql`
  query listAssetsForProperties(
    $search: String!
    $disableUserOrgFilter: Boolean
    $filterBy: LastPositionFilterType
    $pagination: PaginationParam!
    $orgID: String
    $sortBy: SortByVehicles!
    $sortOrder: SortOrder!
  ) {
    vehicles {
      listVehicles(
        param: {
          search: $search
          filterBy: $filterBy
          disableUserOrgFilter: $disableUserOrgFilter
          pagination: $pagination
          orgID: $orgID
          sortBy: $sortBy
          sortOrder: $sortOrder
        }
      ) {
        data {
          ID
          data {
            vehicle {
              fleetName
              ID
              image
            }
            position {
              imei
              sim
              properties {
                field
                value
              }
              latitude
              longitude
              status
              deviceTime
              positioningTime
              battery
              mcb
            }
          }
        }
      }
    }
  }
`

/**
 * __useListAssetsForPropertiesQuery__
 *
 * To run a query within a React component, call `useListAssetsForPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssetsForPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssetsForPropertiesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      disableUserOrgFilter: // value for 'disableUserOrgFilter'
 *      filterBy: // value for 'filterBy'
 *      pagination: // value for 'pagination'
 *      orgID: // value for 'orgID'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useListAssetsForPropertiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListAssetsForPropertiesQuery,
    ListAssetsForPropertiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListAssetsForPropertiesQuery,
    ListAssetsForPropertiesQueryVariables
  >(ListAssetsForPropertiesDocument, options)
}
export function useListAssetsForPropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAssetsForPropertiesQuery,
    ListAssetsForPropertiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListAssetsForPropertiesQuery,
    ListAssetsForPropertiesQueryVariables
  >(ListAssetsForPropertiesDocument, options)
}
export type ListAssetsForPropertiesQueryHookResult = ReturnType<
  typeof useListAssetsForPropertiesQuery
>
export type ListAssetsForPropertiesLazyQueryHookResult = ReturnType<
  typeof useListAssetsForPropertiesLazyQuery
>
export const LastPositionListDocument = gql`
  query lastPositionList(
    $search: String!
    $pagination: PaginationParam!
    $filterBy: LastPositionFilterType
    $orgID: String
  ) {
    vehicles {
      lastPositionList(
        param: {
          search: $search
          pagination: $pagination
          filterBy: $filterBy
          orgID: $orgID
        }
      ) {
        data {
          ID
          data {
            vehicle {
              ...vehicleDataFragment
              fleetTypeID
              fleetType
              fleetModelsID
              remark
            }
            position {
              ...vehiclePositionFragment
            }
          }
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
  ${VehicleDataFragmentFragmentDoc}
  ${VehiclePositionFragmentFragmentDoc}
`

/**
 * __useLastPositionListQuery__
 *
 * To run a query within a React component, call `useLastPositionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPositionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPositionListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *      filterBy: // value for 'filterBy'
 *      orgID: // value for 'orgID'
 *   },
 * });
 */
export function useLastPositionListQuery(
  baseOptions: Apollo.QueryHookOptions<
    LastPositionListQuery,
    LastPositionListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LastPositionListQuery, LastPositionListQueryVariables>(
    LastPositionListDocument,
    options
  )
}
export function useLastPositionListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LastPositionListQuery,
    LastPositionListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LastPositionListQuery,
    LastPositionListQueryVariables
  >(LastPositionListDocument, options)
}
export type LastPositionListQueryHookResult = ReturnType<
  typeof useLastPositionListQuery
>
export type LastPositionListLazyQueryHookResult = ReturnType<
  typeof useLastPositionListLazyQuery
>
export const LastPositionAssetOptionsDocument = gql`
  query lastPositionAssetOptions($orgID: String) {
    vehicles {
      lastPositionList(
        param: { pagination: { active: false }, orgID: $orgID }
      ) {
        data {
          data {
            vehicle {
              ID
              vinNO
            }
          }
        }
      }
    }
  }
`

/**
 * __useLastPositionAssetOptionsQuery__
 *
 * To run a query within a React component, call `useLastPositionAssetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPositionAssetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPositionAssetOptionsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *   },
 * });
 */
export function useLastPositionAssetOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LastPositionAssetOptionsQuery,
    LastPositionAssetOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LastPositionAssetOptionsQuery,
    LastPositionAssetOptionsQueryVariables
  >(LastPositionAssetOptionsDocument, options)
}
export function useLastPositionAssetOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LastPositionAssetOptionsQuery,
    LastPositionAssetOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LastPositionAssetOptionsQuery,
    LastPositionAssetOptionsQueryVariables
  >(LastPositionAssetOptionsDocument, options)
}
export type LastPositionAssetOptionsQueryHookResult = ReturnType<
  typeof useLastPositionAssetOptionsQuery
>
export type LastPositionAssetOptionsLazyQueryHookResult = ReturnType<
  typeof useLastPositionAssetOptionsLazyQuery
>
export const TripHistoryDocument = gql`
  query tripHistory($ID: String!, $startDate: String!, $endDate: String!) {
    vehicles {
      tripHistory(
        param: { ID: $ID, startDate: $startDate, endDate: $endDate, search: "" }
      ) {
        startTime
        distance
        duration
        endTime
        batteryData {
          no
          startCapacity
          endCapacity
          batteryConsumption
        }
        positions {
          positioningTime
          latitude
          longitude
          course
        }
      }
    }
  }
`

/**
 * __useTripHistoryQuery__
 *
 * To run a query within a React component, call `useTripHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripHistoryQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useTripHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    TripHistoryQuery,
    TripHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TripHistoryQuery, TripHistoryQueryVariables>(
    TripHistoryDocument,
    options
  )
}
export function useTripHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TripHistoryQuery,
    TripHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TripHistoryQuery, TripHistoryQueryVariables>(
    TripHistoryDocument,
    options
  )
}
export type TripHistoryQueryHookResult = ReturnType<typeof useTripHistoryQuery>
export type TripHistoryLazyQueryHookResult = ReturnType<
  typeof useTripHistoryLazyQuery
>
export const RouteOverviewDocument = gql`
  query routeOverview($ID: String!, $startTime: String!, $endTime: String!) {
    vehicles {
      routeOverview(
        param: { ID: $ID, startTime: $startTime, endTime: $endTime }
      ) {
        data {
          positioningTime
          deviceTime
          latitude
          longitude
          course
        }
      }
    }
  }
`

/**
 * __useRouteOverviewQuery__
 *
 * To run a query within a React component, call `useRouteOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteOverviewQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useRouteOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteOverviewQuery,
    RouteOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RouteOverviewQuery, RouteOverviewQueryVariables>(
    RouteOverviewDocument,
    options
  )
}
export function useRouteOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteOverviewQuery,
    RouteOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RouteOverviewQuery, RouteOverviewQueryVariables>(
    RouteOverviewDocument,
    options
  )
}
export type RouteOverviewQueryHookResult = ReturnType<
  typeof useRouteOverviewQuery
>
export type RouteOverviewLazyQueryHookResult = ReturnType<
  typeof useRouteOverviewLazyQuery
>
export const GenericPositionHistoryDocument = gql`
  query genericPositionHistory(
    $ID: String!
    $startDate: String!
    $endDate: String!
  ) {
    vehicles {
      positionHistory(
        param: { ID: $ID, startTime: $startDate, endTime: $endDate }
      ) {
        tenant
        vinNo
        licensePlate
        data {
          course
          latitude
          longitude
          positioningTime
          battery
          speed
          properties {
            field
            label: field
            value
          }
          remarks
          event
          mileage
          ignition
          isBlackBox
          address
        }
      }
    }
  }
`

/**
 * __useGenericPositionHistoryQuery__
 *
 * To run a query within a React component, call `useGenericPositionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericPositionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericPositionHistoryQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGenericPositionHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GenericPositionHistoryQuery,
    GenericPositionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GenericPositionHistoryQuery,
    GenericPositionHistoryQueryVariables
  >(GenericPositionHistoryDocument, options)
}
export function useGenericPositionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GenericPositionHistoryQuery,
    GenericPositionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GenericPositionHistoryQuery,
    GenericPositionHistoryQueryVariables
  >(GenericPositionHistoryDocument, options)
}
export type GenericPositionHistoryQueryHookResult = ReturnType<
  typeof useGenericPositionHistoryQuery
>
export type GenericPositionHistoryLazyQueryHookResult = ReturnType<
  typeof useGenericPositionHistoryLazyQuery
>
export const ProductivityListVehicleDocument = gql`
  query productivityListVehicle($param: LastPositionListParam) {
    vehicles {
      listVehicles(param: $param) {
        data {
          ID
          data {
            vehicle {
              fleetName
              ID
            }
          }
        }
      }
    }
  }
`

/**
 * __useProductivityListVehicleQuery__
 *
 * To run a query within a React component, call `useProductivityListVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductivityListVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductivityListVehicleQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useProductivityListVehicleQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductivityListVehicleQuery,
    ProductivityListVehicleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductivityListVehicleQuery,
    ProductivityListVehicleQueryVariables
  >(ProductivityListVehicleDocument, options)
}
export function useProductivityListVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductivityListVehicleQuery,
    ProductivityListVehicleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductivityListVehicleQuery,
    ProductivityListVehicleQueryVariables
  >(ProductivityListVehicleDocument, options)
}
export type ProductivityListVehicleQueryHookResult = ReturnType<
  typeof useProductivityListVehicleQuery
>
export type ProductivityListVehicleLazyQueryHookResult = ReturnType<
  typeof useProductivityListVehicleLazyQuery
>
export const DetailVehicleDocument = gql`
  query detailVehicle($id: String!) {
    vehicles {
      lastPosition(id: $id) {
        ID
        data {
          position {
            course
            status
            speed
            positioningTime
            latitude
            longitude
            ignition
            imei
            mileage
            properties {
              field
              value
            }
          }
          vehicle {
            active
            deviceID
            deviceModel
            driver
            driverID
            fleetModels
            fleetTypeID
            fleetType
            fleetModelsID
            fleetName
            ID
            remark
            licensePlate
            properties {
              field
              value
            }
            status
            tags {
              field
              value
            }
            vinNO
            tenantID
          }
        }
      }
    }
  }
`

/**
 * __useDetailVehicleQuery__
 *
 * To run a query within a React component, call `useDetailVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailVehicleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailVehicleQuery(
  baseOptions: Apollo.QueryHookOptions<
    DetailVehicleQuery,
    DetailVehicleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DetailVehicleQuery, DetailVehicleQueryVariables>(
    DetailVehicleDocument,
    options
  )
}
export function useDetailVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DetailVehicleQuery,
    DetailVehicleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DetailVehicleQuery, DetailVehicleQueryVariables>(
    DetailVehicleDocument,
    options
  )
}
export type DetailVehicleQueryHookResult = ReturnType<
  typeof useDetailVehicleQuery
>
export type DetailVehicleLazyQueryHookResult = ReturnType<
  typeof useDetailVehicleLazyQuery
>
export const GetReportDocument = gql`
  query getReport($filename: String!) {
    vehicles {
      getReport(filename: $filename) {
        startTime
        endTime
        startCoordinate
        endCoordinate
        duration
        distance
      }
    }
  }
`

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(
    GetReportDocument,
    options
  )
}
export function useGetReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportQuery,
    GetReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(
    GetReportDocument,
    options
  )
}
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>
export type GetReportLazyQueryHookResult = ReturnType<
  typeof useGetReportLazyQuery
>
export const ListReportDocument = gql`
  query listReport($search: String!, $pagination: PaginationParam!) {
    vehicles {
      listReport(param: { search: $search, pagination: $pagination }) {
        data {
          ID
          date
          type
          fleetID
          fleetName
          status
          fileUrl
          requestedAt
        }
        pagination {
          totalPage
          totalRecord
          next
          last
          current
          before
          first
          perPage
        }
      }
    }
  }
`

/**
 * __useListReportQuery__
 *
 * To run a query within a React component, call `useListReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReportQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListReportQuery,
    ListReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListReportQuery, ListReportQueryVariables>(
    ListReportDocument,
    options
  )
}
export function useListReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListReportQuery,
    ListReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListReportQuery, ListReportQueryVariables>(
    ListReportDocument,
    options
  )
}
export type ListReportQueryHookResult = ReturnType<typeof useListReportQuery>
export type ListReportLazyQueryHookResult = ReturnType<
  typeof useListReportLazyQuery
>
export const AssetOptionsDocument = gql`
  query assetOptions(
    $search: String!
    $filterByAssignment: VehicleFilterType
    $orgID: String
    $pagination: PaginationParam
    $sortBy: SortByVehicles
    $sortOrder: SortOrder
  ) {
    vehicles {
      listVehicles(
        param: {
          search: $search
          filterByAssignment: $filterByAssignment
          pagination: $pagination
          orgID: $orgID
          sortBy: $sortBy
          sortOrder: $sortOrder
        }
      ) {
        data {
          ID
          data {
            vehicle {
              fleetModels
              fleetName
              ID
            }
          }
        }
      }
    }
  }
`

/**
 * __useAssetOptionsQuery__
 *
 * To run a query within a React component, call `useAssetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filterByAssignment: // value for 'filterByAssignment'
 *      orgID: // value for 'orgID'
 *      pagination: // value for 'pagination'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAssetOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetOptionsQuery,
    AssetOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssetOptionsQuery, AssetOptionsQueryVariables>(
    AssetOptionsDocument,
    options
  )
}
export function useAssetOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetOptionsQuery,
    AssetOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssetOptionsQuery, AssetOptionsQueryVariables>(
    AssetOptionsDocument,
    options
  )
}
export type AssetOptionsQueryHookResult = ReturnType<
  typeof useAssetOptionsQuery
>
export type AssetOptionsLazyQueryHookResult = ReturnType<
  typeof useAssetOptionsLazyQuery
>
export const AssetDeviceListOptionsDocument = gql`
  query assetDeviceListOptions(
    $search: String!
    $disableUserOrgFilter: Boolean
    $filterByAssignment: VehicleFilterType
    $orgID: String
    $pagination: PaginationParam
  ) {
    vehicles {
      listVehicles(
        param: {
          search: $search
          filterByAssignment: $filterByAssignment
          disableUserOrgFilter: $disableUserOrgFilter
          pagination: $pagination
          orgID: $orgID
        }
      ) {
        data {
          ID
          data {
            vehicle {
              fleetName
              ID
              vinNO
            }
          }
        }
      }
    }
  }
`

/**
 * __useAssetDeviceListOptionsQuery__
 *
 * To run a query within a React component, call `useAssetDeviceListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetDeviceListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetDeviceListOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      disableUserOrgFilter: // value for 'disableUserOrgFilter'
 *      filterByAssignment: // value for 'filterByAssignment'
 *      orgID: // value for 'orgID'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAssetDeviceListOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetDeviceListOptionsQuery,
    AssetDeviceListOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AssetDeviceListOptionsQuery,
    AssetDeviceListOptionsQueryVariables
  >(AssetDeviceListOptionsDocument, options)
}
export function useAssetDeviceListOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetDeviceListOptionsQuery,
    AssetDeviceListOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AssetDeviceListOptionsQuery,
    AssetDeviceListOptionsQueryVariables
  >(AssetDeviceListOptionsDocument, options)
}
export type AssetDeviceListOptionsQueryHookResult = ReturnType<
  typeof useAssetDeviceListOptionsQuery
>
export type AssetDeviceListOptionsLazyQueryHookResult = ReturnType<
  typeof useAssetDeviceListOptionsLazyQuery
>
export const ListChartOdometerDocument = gql`
  query listChartOdometer($param: TravelParam, $pagination: PaginationParam) {
    vehicles {
      GetOdomoterRecords(param: $param, pagination: $pagination) {
        travelData {
          name
          travelled
          target
          fleetType
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useListChartOdometerQuery__
 *
 * To run a query within a React component, call `useListChartOdometerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChartOdometerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChartOdometerQuery({
 *   variables: {
 *      param: // value for 'param'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListChartOdometerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChartOdometerQuery,
    ListChartOdometerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListChartOdometerQuery,
    ListChartOdometerQueryVariables
  >(ListChartOdometerDocument, options)
}
export function useListChartOdometerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChartOdometerQuery,
    ListChartOdometerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListChartOdometerQuery,
    ListChartOdometerQueryVariables
  >(ListChartOdometerDocument, options)
}
export type ListChartOdometerQueryHookResult = ReturnType<
  typeof useListChartOdometerQuery
>
export type ListChartOdometerLazyQueryHookResult = ReturnType<
  typeof useListChartOdometerLazyQuery
>
export const ListCycleRouteDocument = gql`
  query listCycleRoute($id: String!, $date: String!) {
    vehicles {
      GetRouteList(id: $id, date: $date) {
        routeData {
          route
          startTime
          endTime
          distance
        }
        fleetCycleSummary {
          ID
          fleetID
          poolGeofenceID
          departureTime
          startMileageKm
          firstRouteName
          firstStationGeofenceID
          firstStationArrivalTime
          firstStationMileageKm
          returnFromRouteName
          returnFromGeofenceID
          returnDepartureTime
          returnArrivalTime
          returnMileageKm
          startBatterySocPct
          returnBatterySocPct
          batteryUsageKwh
          lastStationMileageKm
          trip11MileageKm
          trip12MileageKm
          trip1MileageKm
          trip2MileageKm
          trip21MileageKm
          trip22MileageKm
        }
      }
    }
  }
`

/**
 * __useListCycleRouteQuery__
 *
 * To run a query within a React component, call `useListCycleRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCycleRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCycleRouteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useListCycleRouteQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCycleRouteQuery,
    ListCycleRouteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCycleRouteQuery, ListCycleRouteQueryVariables>(
    ListCycleRouteDocument,
    options
  )
}
export function useListCycleRouteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCycleRouteQuery,
    ListCycleRouteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCycleRouteQuery, ListCycleRouteQueryVariables>(
    ListCycleRouteDocument,
    options
  )
}
export type ListCycleRouteQueryHookResult = ReturnType<
  typeof useListCycleRouteQuery
>
export type ListCycleRouteLazyQueryHookResult = ReturnType<
  typeof useListCycleRouteLazyQuery
>
export const NightTimeAlertTotalDocument = gql`
  query nightTimeAlertTotal($param: HistoryParam) {
    vehicles {
      listNighttimeAlert(param: $param) {
        count
      }
    }
  }
`

/**
 * __useNightTimeAlertTotalQuery__
 *
 * To run a query within a React component, call `useNightTimeAlertTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useNightTimeAlertTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNightTimeAlertTotalQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useNightTimeAlertTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NightTimeAlertTotalQuery,
    NightTimeAlertTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NightTimeAlertTotalQuery,
    NightTimeAlertTotalQueryVariables
  >(NightTimeAlertTotalDocument, options)
}
export function useNightTimeAlertTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NightTimeAlertTotalQuery,
    NightTimeAlertTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NightTimeAlertTotalQuery,
    NightTimeAlertTotalQueryVariables
  >(NightTimeAlertTotalDocument, options)
}
export type NightTimeAlertTotalQueryHookResult = ReturnType<
  typeof useNightTimeAlertTotalQuery
>
export type NightTimeAlertTotalLazyQueryHookResult = ReturnType<
  typeof useNightTimeAlertTotalLazyQuery
>
export const ListNightTimeAlertDocument = gql`
  query listNightTimeAlert($param: HistoryParam) {
    vehicles {
      listNighttimeAlert(param: $param) {
        data {
          startTime
          endTime
          duration
          distance
          batteryData {
            no
            startCapacity
            endCapacity
            batteryConsumption
          }
          positions {
            course
            latitude
            longitude
            positioningTime
          }
        }
      }
    }
  }
`

/**
 * __useListNightTimeAlertQuery__
 *
 * To run a query within a React component, call `useListNightTimeAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNightTimeAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNightTimeAlertQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useListNightTimeAlertQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListNightTimeAlertQuery,
    ListNightTimeAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListNightTimeAlertQuery,
    ListNightTimeAlertQueryVariables
  >(ListNightTimeAlertDocument, options)
}
export function useListNightTimeAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNightTimeAlertQuery,
    ListNightTimeAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListNightTimeAlertQuery,
    ListNightTimeAlertQueryVariables
  >(ListNightTimeAlertDocument, options)
}
export type ListNightTimeAlertQueryHookResult = ReturnType<
  typeof useListNightTimeAlertQuery
>
export type ListNightTimeAlertLazyQueryHookResult = ReturnType<
  typeof useListNightTimeAlertLazyQuery
>
export const ExcessiveIdlingTotalDocument = gql`
  query excessiveIdlingTotal($param: HistoryParam) {
    vehicles {
      ListExcessiveIdling(param: $param) {
        total
      }
    }
  }
`

/**
 * __useExcessiveIdlingTotalQuery__
 *
 * To run a query within a React component, call `useExcessiveIdlingTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcessiveIdlingTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExcessiveIdlingTotalQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useExcessiveIdlingTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExcessiveIdlingTotalQuery,
    ExcessiveIdlingTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ExcessiveIdlingTotalQuery,
    ExcessiveIdlingTotalQueryVariables
  >(ExcessiveIdlingTotalDocument, options)
}
export function useExcessiveIdlingTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExcessiveIdlingTotalQuery,
    ExcessiveIdlingTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ExcessiveIdlingTotalQuery,
    ExcessiveIdlingTotalQueryVariables
  >(ExcessiveIdlingTotalDocument, options)
}
export type ExcessiveIdlingTotalQueryHookResult = ReturnType<
  typeof useExcessiveIdlingTotalQuery
>
export type ExcessiveIdlingTotalLazyQueryHookResult = ReturnType<
  typeof useExcessiveIdlingTotalLazyQuery
>
export const ListExcessiveIdlingDocument = gql`
  query listExcessiveIdling($param: HistoryParam) {
    vehicles {
      ListExcessiveIdling(param: $param) {
        data {
          startTime
          endTime
          duration
          latitude
          longitude
        }
      }
    }
  }
`

/**
 * __useListExcessiveIdlingQuery__
 *
 * To run a query within a React component, call `useListExcessiveIdlingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExcessiveIdlingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExcessiveIdlingQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useListExcessiveIdlingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListExcessiveIdlingQuery,
    ListExcessiveIdlingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListExcessiveIdlingQuery,
    ListExcessiveIdlingQueryVariables
  >(ListExcessiveIdlingDocument, options)
}
export function useListExcessiveIdlingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListExcessiveIdlingQuery,
    ListExcessiveIdlingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListExcessiveIdlingQuery,
    ListExcessiveIdlingQueryVariables
  >(ListExcessiveIdlingDocument, options)
}
export type ListExcessiveIdlingQueryHookResult = ReturnType<
  typeof useListExcessiveIdlingQuery
>
export type ListExcessiveIdlingLazyQueryHookResult = ReturnType<
  typeof useListExcessiveIdlingLazyQuery
>
export const TamperingTotalDocument = gql`
  query tamperingTotal($param: HistoryParam) {
    vehicles {
      ListTampering(param: $param) {
        total
      }
    }
  }
`

/**
 * __useTamperingTotalQuery__
 *
 * To run a query within a React component, call `useTamperingTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTamperingTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTamperingTotalQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useTamperingTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TamperingTotalQuery,
    TamperingTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TamperingTotalQuery, TamperingTotalQueryVariables>(
    TamperingTotalDocument,
    options
  )
}
export function useTamperingTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TamperingTotalQuery,
    TamperingTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TamperingTotalQuery, TamperingTotalQueryVariables>(
    TamperingTotalDocument,
    options
  )
}
export type TamperingTotalQueryHookResult = ReturnType<
  typeof useTamperingTotalQuery
>
export type TamperingTotalLazyQueryHookResult = ReturnType<
  typeof useTamperingTotalLazyQuery
>
export const ListTamperingDocument = gql`
  query listTampering($param: HistoryParam) {
    vehicles {
      ListTampering(param: $param) {
        data {
          time
          latitude
          longitude
        }
      }
    }
  }
`

/**
 * __useListTamperingQuery__
 *
 * To run a query within a React component, call `useListTamperingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTamperingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTamperingQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useListTamperingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTamperingQuery,
    ListTamperingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListTamperingQuery, ListTamperingQueryVariables>(
    ListTamperingDocument,
    options
  )
}
export function useListTamperingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTamperingQuery,
    ListTamperingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListTamperingQuery, ListTamperingQueryVariables>(
    ListTamperingDocument,
    options
  )
}
export type ListTamperingQueryHookResult = ReturnType<
  typeof useListTamperingQuery
>
export type ListTamperingLazyQueryHookResult = ReturnType<
  typeof useListTamperingLazyQuery
>
export const DashboardStatisticDocument = gql`
  query dashboardStatistic($param: HistoryParam) {
    vehicles {
      getDashboardStatictic(param: $param) {
        duration
        avgSpeed
        topSpeed
        distance
      }
    }
  }
`

/**
 * __useDashboardStatisticQuery__
 *
 * To run a query within a React component, call `useDashboardStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardStatisticQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useDashboardStatisticQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardStatisticQuery,
    DashboardStatisticQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DashboardStatisticQuery,
    DashboardStatisticQueryVariables
  >(DashboardStatisticDocument, options)
}
export function useDashboardStatisticLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardStatisticQuery,
    DashboardStatisticQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DashboardStatisticQuery,
    DashboardStatisticQueryVariables
  >(DashboardStatisticDocument, options)
}
export type DashboardStatisticQueryHookResult = ReturnType<
  typeof useDashboardStatisticQuery
>
export type DashboardStatisticLazyQueryHookResult = ReturnType<
  typeof useDashboardStatisticLazyQuery
>
export const DrivingScoreDocument = gql`
  query DrivingScore($param: HistoryParam) {
    vehicles {
      GetDrivingScore(param: $param) {
        score
        count
        mean
        median
        overSpeedcount
        harshBreakingcount
        crashDetectioncount
      }
    }
  }
`

/**
 * __useDrivingScoreQuery__
 *
 * To run a query within a React component, call `useDrivingScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrivingScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrivingScoreQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useDrivingScoreQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DrivingScoreQuery,
    DrivingScoreQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrivingScoreQuery, DrivingScoreQueryVariables>(
    DrivingScoreDocument,
    options
  )
}
export function useDrivingScoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrivingScoreQuery,
    DrivingScoreQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrivingScoreQuery, DrivingScoreQueryVariables>(
    DrivingScoreDocument,
    options
  )
}
export type DrivingScoreQueryHookResult = ReturnType<
  typeof useDrivingScoreQuery
>
export type DrivingScoreLazyQueryHookResult = ReturnType<
  typeof useDrivingScoreLazyQuery
>
export const DrivingScoreListDocument = gql`
  query DrivingScoreList($param: HistoryParam) {
    vehicles {
      GetDrivingScore(param: $param) {
        score
        count
        mean
        median
        overSpeed {
          time
          value
          latitude
          longitude
          speed
        }
        harshBreaking {
          time
          value
          latitude
          longitude
          speed
        }
        crashDetection {
          time
          value
          latitude
          longitude
          speed
        }
        overSpeedcount
        harshBreakingcount
        crashDetectioncount
      }
    }
  }
`

/**
 * __useDrivingScoreListQuery__
 *
 * To run a query within a React component, call `useDrivingScoreListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrivingScoreListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrivingScoreListQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useDrivingScoreListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DrivingScoreListQuery,
    DrivingScoreListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrivingScoreListQuery, DrivingScoreListQueryVariables>(
    DrivingScoreListDocument,
    options
  )
}
export function useDrivingScoreListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrivingScoreListQuery,
    DrivingScoreListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DrivingScoreListQuery,
    DrivingScoreListQueryVariables
  >(DrivingScoreListDocument, options)
}
export type DrivingScoreListQueryHookResult = ReturnType<
  typeof useDrivingScoreListQuery
>
export type DrivingScoreListLazyQueryHookResult = ReturnType<
  typeof useDrivingScoreListLazyQuery
>
export const GeofenceAlertDocument = gql`
  query geofenceAlert(
    $param: ListParam
    $startDate: String
    $endDate: String
    $fleetID: String
  ) {
    geofences {
      fetchGeofenceEvents(
        param: $param
        startDate: $startDate
        endDate: $endDate
        fleetid: $fleetID
      ) {
        data {
          ID
          time
          geofenceId
          orgId
          fleetId
          event
          fleetName
          coordinate
        }
      }
    }
  }
`

/**
 * __useGeofenceAlertQuery__
 *
 * To run a query within a React component, call `useGeofenceAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeofenceAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeofenceAlertQuery({
 *   variables: {
 *      param: // value for 'param'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      fleetID: // value for 'fleetID'
 *   },
 * });
 */
export function useGeofenceAlertQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GeofenceAlertQuery,
    GeofenceAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GeofenceAlertQuery, GeofenceAlertQueryVariables>(
    GeofenceAlertDocument,
    options
  )
}
export function useGeofenceAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeofenceAlertQuery,
    GeofenceAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GeofenceAlertQuery, GeofenceAlertQueryVariables>(
    GeofenceAlertDocument,
    options
  )
}
export type GeofenceAlertQueryHookResult = ReturnType<
  typeof useGeofenceAlertQuery
>
export type GeofenceAlertLazyQueryHookResult = ReturnType<
  typeof useGeofenceAlertLazyQuery
>
export const OverSpeedAlertDocument = gql`
  query overSpeedAlert(
    $param: ListParam
    $startDate: String
    $endDate: String
    $fleetid: String
    $event: EventType
  ) {
    geofences {
      fetchNotificationsEvents(
        param: $param
        startDate: $startDate
        endDate: $endDate
        event: $event
        fleetid: $fleetid
      ) {
        data {
          ID
          time
          geofenceId
          orgId
          fleetId
          event
          fleetName
          coordinate
        }
      }
    }
  }
`

/**
 * __useOverSpeedAlertQuery__
 *
 * To run a query within a React component, call `useOverSpeedAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverSpeedAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverSpeedAlertQuery({
 *   variables: {
 *      param: // value for 'param'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      fleetid: // value for 'fleetid'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useOverSpeedAlertQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OverSpeedAlertQuery,
    OverSpeedAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OverSpeedAlertQuery, OverSpeedAlertQueryVariables>(
    OverSpeedAlertDocument,
    options
  )
}
export function useOverSpeedAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverSpeedAlertQuery,
    OverSpeedAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OverSpeedAlertQuery, OverSpeedAlertQueryVariables>(
    OverSpeedAlertDocument,
    options
  )
}
export type OverSpeedAlertQueryHookResult = ReturnType<
  typeof useOverSpeedAlertQuery
>
export type OverSpeedAlertLazyQueryHookResult = ReturnType<
  typeof useOverSpeedAlertLazyQuery
>
export const StopHistoryDocument = gql`
  query stopHistory($param: HistoryParam) {
    vehicles {
      stopHistory(param: $param) {
        startTime
        endTime
        duration
        distance
        avgSpeed
        topSpeed
        driver
        batteryData {
          no
          startCapacity
          endCapacity
          batteryConsumption
        }
        positions {
          course
          latitude
          longitude
          positioningTime
        }
      }
    }
  }
`

/**
 * __useStopHistoryQuery__
 *
 * To run a query within a React component, call `useStopHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStopHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStopHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useStopHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StopHistoryQuery,
    StopHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StopHistoryQuery, StopHistoryQueryVariables>(
    StopHistoryDocument,
    options
  )
}
export function useStopHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StopHistoryQuery,
    StopHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StopHistoryQuery, StopHistoryQueryVariables>(
    StopHistoryDocument,
    options
  )
}
export type StopHistoryQueryHookResult = ReturnType<typeof useStopHistoryQuery>
export type StopHistoryLazyQueryHookResult = ReturnType<
  typeof useStopHistoryLazyQuery
>
export const EngineHistoryDocument = gql`
  query engineHistory($param: HistoryParam) {
    vehicles {
      ignitionHistory(param: $param) {
        startTime
        endTime
        duration
        distance
        avgSpeed
        topSpeed
        driver
        ignition
        batteryData {
          no
          startCapacity
          endCapacity
          batteryConsumption
        }
        positions {
          course
          latitude
          longitude
          positioningTime
        }
      }
    }
  }
`

/**
 * __useEngineHistoryQuery__
 *
 * To run a query within a React component, call `useEngineHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngineHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngineHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useEngineHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EngineHistoryQuery,
    EngineHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EngineHistoryQuery, EngineHistoryQueryVariables>(
    EngineHistoryDocument,
    options
  )
}
export function useEngineHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EngineHistoryQuery,
    EngineHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EngineHistoryQuery, EngineHistoryQueryVariables>(
    EngineHistoryDocument,
    options
  )
}
export type EngineHistoryQueryHookResult = ReturnType<
  typeof useEngineHistoryQuery
>
export type EngineHistoryLazyQueryHookResult = ReturnType<
  typeof useEngineHistoryLazyQuery
>
export const EventHistoryDocument = gql`
  query eventHistory($param: HistoryParam) {
    vehicles {
      listTHREvent(param: $param) {
        driver
        badge
        time
        event
        ignition
        speed
        adress
      }
    }
  }
`

/**
 * __useEventHistoryQuery__
 *
 * To run a query within a React component, call `useEventHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useEventHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EventHistoryQuery,
    EventHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EventHistoryQuery, EventHistoryQueryVariables>(
    EventHistoryDocument,
    options
  )
}
export function useEventHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventHistoryQuery,
    EventHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EventHistoryQuery, EventHistoryQueryVariables>(
    EventHistoryDocument,
    options
  )
}
export type EventHistoryQueryHookResult = ReturnType<
  typeof useEventHistoryQuery
>
export type EventHistoryLazyQueryHookResult = ReturnType<
  typeof useEventHistoryLazyQuery
>
export const GeofenceThrHistoryDocument = gql`
  query geofenceTHRHistory($param: HistoryParam) {
    geofences {
      fetchTHRgeofenceEvents(param: $param) {
        driver
        badge
        time
        dir
        category
        name
        address
      }
    }
  }
`

/**
 * __useGeofenceThrHistoryQuery__
 *
 * To run a query within a React component, call `useGeofenceThrHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeofenceThrHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeofenceThrHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useGeofenceThrHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GeofenceThrHistoryQuery,
    GeofenceThrHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GeofenceThrHistoryQuery,
    GeofenceThrHistoryQueryVariables
  >(GeofenceThrHistoryDocument, options)
}
export function useGeofenceThrHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeofenceThrHistoryQuery,
    GeofenceThrHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GeofenceThrHistoryQuery,
    GeofenceThrHistoryQueryVariables
  >(GeofenceThrHistoryDocument, options)
}
export type GeofenceThrHistoryQueryHookResult = ReturnType<
  typeof useGeofenceThrHistoryQuery
>
export type GeofenceThrHistoryLazyQueryHookResult = ReturnType<
  typeof useGeofenceThrHistoryLazyQuery
>
export const RashDrivingHistoryDocument = gql`
  query rashDrivingHistory($param: HistoryParam) {
    vehicles {
      listTHRrashDriving(param: $param) {
        driver
        badge
        time
        event
        ignition
        speed
        adress
      }
    }
  }
`

/**
 * __useRashDrivingHistoryQuery__
 *
 * To run a query within a React component, call `useRashDrivingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRashDrivingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRashDrivingHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useRashDrivingHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RashDrivingHistoryQuery,
    RashDrivingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RashDrivingHistoryQuery,
    RashDrivingHistoryQueryVariables
  >(RashDrivingHistoryDocument, options)
}
export function useRashDrivingHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RashDrivingHistoryQuery,
    RashDrivingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RashDrivingHistoryQuery,
    RashDrivingHistoryQueryVariables
  >(RashDrivingHistoryDocument, options)
}
export type RashDrivingHistoryQueryHookResult = ReturnType<
  typeof useRashDrivingHistoryQuery
>
export type RashDrivingHistoryLazyQueryHookResult = ReturnType<
  typeof useRashDrivingHistoryLazyQuery
>
export const ReverseHistoryDocument = gql`
  query reverseHistory($param: HistoryParam) {
    vehicles {
      listTHRreverse(param: $param) {
        driver
        badge
        startTime
        endTime
        avgSpeed
        topSpeed
        distance
        duration
        adress
        area
        latitude
        longitude
      }
    }
  }
`

/**
 * __useReverseHistoryQuery__
 *
 * To run a query within a React component, call `useReverseHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReverseHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReverseHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useReverseHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReverseHistoryQuery,
    ReverseHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReverseHistoryQuery, ReverseHistoryQueryVariables>(
    ReverseHistoryDocument,
    options
  )
}
export function useReverseHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReverseHistoryQuery,
    ReverseHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReverseHistoryQuery, ReverseHistoryQueryVariables>(
    ReverseHistoryDocument,
    options
  )
}
export type ReverseHistoryQueryHookResult = ReturnType<
  typeof useReverseHistoryQuery
>
export type ReverseHistoryLazyQueryHookResult = ReturnType<
  typeof useReverseHistoryLazyQuery
>
export const DetailHistoryDocument = gql`
  query detailHistory($param: HistoryParam, $pagination: PaginationParam) {
    vehicles {
      listTHRDetail(param: $param, pagination: $pagination) {
        data {
          driver
          badge
          rfid
          ignition
          time
          speed
          speedLimit
          adress
          place
          latitude
          longitude
          temperature
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useDetailHistoryQuery__
 *
 * To run a query within a React component, call `useDetailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDetailHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DetailHistoryQuery,
    DetailHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DetailHistoryQuery, DetailHistoryQueryVariables>(
    DetailHistoryDocument,
    options
  )
}
export function useDetailHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DetailHistoryQuery,
    DetailHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DetailHistoryQuery, DetailHistoryQueryVariables>(
    DetailHistoryDocument,
    options
  )
}
export type DetailHistoryQueryHookResult = ReturnType<
  typeof useDetailHistoryQuery
>
export type DetailHistoryLazyQueryHookResult = ReturnType<
  typeof useDetailHistoryLazyQuery
>
export const SpeedingHistoryDocument = gql`
  query speedingHistory($param: HistoryParam) {
    vehicles {
      listTHRSpeed(param: $param) {
        driver
        badge
        time
        duration
        topSpeed
        speedLimit
        distance
        latitude
        longitude
        adress
        area
      }
    }
  }
`

/**
 * __useSpeedingHistoryQuery__
 *
 * To run a query within a React component, call `useSpeedingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeedingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeedingHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useSpeedingHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpeedingHistoryQuery,
    SpeedingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SpeedingHistoryQuery, SpeedingHistoryQueryVariables>(
    SpeedingHistoryDocument,
    options
  )
}
export function useSpeedingHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpeedingHistoryQuery,
    SpeedingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SpeedingHistoryQuery,
    SpeedingHistoryQueryVariables
  >(SpeedingHistoryDocument, options)
}
export type SpeedingHistoryQueryHookResult = ReturnType<
  typeof useSpeedingHistoryQuery
>
export type SpeedingHistoryLazyQueryHookResult = ReturnType<
  typeof useSpeedingHistoryLazyQuery
>
export const DrivingHistoryDocument = gql`
  query drivingHistory($param: HistoryParam) {
    vehicles {
      listTHRDriving(param: $param) {
        driver
        badge
        rfid
        startTime
        endTime
        avgSpeed
        topSpeed
        distance
        duration
        adressStart
        addressEnd
      }
    }
  }
`

/**
 * __useDrivingHistoryQuery__
 *
 * To run a query within a React component, call `useDrivingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrivingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrivingHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useDrivingHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DrivingHistoryQuery,
    DrivingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrivingHistoryQuery, DrivingHistoryQueryVariables>(
    DrivingHistoryDocument,
    options
  )
}
export function useDrivingHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrivingHistoryQuery,
    DrivingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrivingHistoryQuery, DrivingHistoryQueryVariables>(
    DrivingHistoryDocument,
    options
  )
}
export type DrivingHistoryQueryHookResult = ReturnType<
  typeof useDrivingHistoryQuery
>
export type DrivingHistoryLazyQueryHookResult = ReturnType<
  typeof useDrivingHistoryLazyQuery
>
export const IdleHistoryDocument = gql`
  query idleHistory($param: HistoryParam) {
    vehicles {
      idleHistory(param: $param) {
        startTime
        endTime
        duration
        distance
        avgSpeed
        topSpeed
        driver
        batteryData {
          no
          startCapacity
          endCapacity
          batteryConsumption
        }
        positions {
          course
          latitude
          longitude
          positioningTime
        }
      }
    }
  }
`

/**
 * __useIdleHistoryQuery__
 *
 * To run a query within a React component, call `useIdleHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdleHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdleHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useIdleHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IdleHistoryQuery,
    IdleHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IdleHistoryQuery, IdleHistoryQueryVariables>(
    IdleHistoryDocument,
    options
  )
}
export function useIdleHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IdleHistoryQuery,
    IdleHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IdleHistoryQuery, IdleHistoryQueryVariables>(
    IdleHistoryDocument,
    options
  )
}
export type IdleHistoryQueryHookResult = ReturnType<typeof useIdleHistoryQuery>
export type IdleHistoryLazyQueryHookResult = ReturnType<
  typeof useIdleHistoryLazyQuery
>
export const ListTimelineHistoryDocument = gql`
  query listTimelineHistory($param: HistoryParam!) {
    vehicles {
      GetTimeline(param: $param) {
        data {
          type
          startTime
          endTime
          address
          driver
          avgSpeed
          topSpeed
          distance
          duration
        }
      }
    }
  }
`

/**
 * __useListTimelineHistoryQuery__
 *
 * To run a query within a React component, call `useListTimelineHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTimelineHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTimelineHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useListTimelineHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTimelineHistoryQuery,
    ListTimelineHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListTimelineHistoryQuery,
    ListTimelineHistoryQueryVariables
  >(ListTimelineHistoryDocument, options)
}
export function useListTimelineHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTimelineHistoryQuery,
    ListTimelineHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListTimelineHistoryQuery,
    ListTimelineHistoryQueryVariables
  >(ListTimelineHistoryDocument, options)
}
export type ListTimelineHistoryQueryHookResult = ReturnType<
  typeof useListTimelineHistoryQuery
>
export type ListTimelineHistoryLazyQueryHookResult = ReturnType<
  typeof useListTimelineHistoryLazyQuery
>
export const ReportListGroupDocument = gql`
  query reportListGroup($id: String!) {
    vehicles {
      GetVehiclesReportListS3(id: $id) {
        reportFileData {
          url
          filename
        }
      }
    }
  }
`

/**
 * __useReportListGroupQuery__
 *
 * To run a query within a React component, call `useReportListGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportListGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportListGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportListGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportListGroupQuery,
    ReportListGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReportListGroupQuery, ReportListGroupQueryVariables>(
    ReportListGroupDocument,
    options
  )
}
export function useReportListGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportListGroupQuery,
    ReportListGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ReportListGroupQuery,
    ReportListGroupQueryVariables
  >(ReportListGroupDocument, options)
}
export type ReportListGroupQueryHookResult = ReturnType<
  typeof useReportListGroupQuery
>
export type ReportListGroupLazyQueryHookResult = ReturnType<
  typeof useReportListGroupLazyQuery
>
export const ListWebHookDocument = gql`
  query listWebHook($param: ListParam, $orgID: String!) {
    geofences {
      ListWebhookUrl(param: $param, orgID: $orgID) {
        data {
          id
          url
          key
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useListWebHookQuery__
 *
 * To run a query within a React component, call `useListWebHookQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebHookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebHookQuery({
 *   variables: {
 *      param: // value for 'param'
 *      orgID: // value for 'orgID'
 *   },
 * });
 */
export function useListWebHookQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListWebHookQuery,
    ListWebHookQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListWebHookQuery, ListWebHookQueryVariables>(
    ListWebHookDocument,
    options
  )
}
export function useListWebHookLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListWebHookQuery,
    ListWebHookQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListWebHookQuery, ListWebHookQueryVariables>(
    ListWebHookDocument,
    options
  )
}
export type ListWebHookQueryHookResult = ReturnType<typeof useListWebHookQuery>
export type ListWebHookLazyQueryHookResult = ReturnType<
  typeof useListWebHookLazyQuery
>
export const RequestReportDocument = gql`
  mutation requestReport($fleetID: String!, $type: String!, $date: String!) {
    vehicles {
      requestReport(param: { fleetID: $fleetID, type: $type, date: $date }) {
        status
        requestedAt
        ID
        type
        fleetID
        status
        fileUrl
        date
      }
    }
  }
`

/**
 * __useRequestReportMutation__
 *
 * To run a mutation, you first call `useRequestReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReportMutation, { data, loading, error }] = useRequestReportMutation({
 *   variables: {
 *      fleetID: // value for 'fleetID'
 *      type: // value for 'type'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useRequestReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestReportMutation,
    RequestReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestReportMutation,
    RequestReportMutationVariables
  >(RequestReportDocument, options)
}
export type RequestReportMutationHookResult = ReturnType<
  typeof useRequestReportMutation
>
export const ListVehicleModelsDocument = gql`
  query listVehicleModels($param: ModelListParam) {
    vehicles {
      listVehicleModels(param: $param) {
        data {
          model
          ID
        }
      }
    }
  }
`

/**
 * __useListVehicleModelsQuery__
 *
 * To run a query within a React component, call `useListVehicleModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVehicleModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVehicleModelsQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useListVehicleModelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListVehicleModelsQuery,
    ListVehicleModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListVehicleModelsQuery,
    ListVehicleModelsQueryVariables
  >(ListVehicleModelsDocument, options)
}
export function useListVehicleModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListVehicleModelsQuery,
    ListVehicleModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListVehicleModelsQuery,
    ListVehicleModelsQueryVariables
  >(ListVehicleModelsDocument, options)
}
export type ListVehicleModelsQueryHookResult = ReturnType<
  typeof useListVehicleModelsQuery
>
export type ListVehicleModelsLazyQueryHookResult = ReturnType<
  typeof useListVehicleModelsLazyQuery
>
export const ListVehicleTypesDocument = gql`
  query listVehicleTypes {
    vehicles {
      listVehicleTypes {
        data {
          ID
          name
        }
      }
    }
  }
`

/**
 * __useListVehicleTypesQuery__
 *
 * To run a query within a React component, call `useListVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVehicleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListVehicleTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListVehicleTypesQuery,
    ListVehicleTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListVehicleTypesQuery, ListVehicleTypesQueryVariables>(
    ListVehicleTypesDocument,
    options
  )
}
export function useListVehicleTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListVehicleTypesQuery,
    ListVehicleTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListVehicleTypesQuery,
    ListVehicleTypesQueryVariables
  >(ListVehicleTypesDocument, options)
}
export type ListVehicleTypesQueryHookResult = ReturnType<
  typeof useListVehicleTypesQuery
>
export type ListVehicleTypesLazyQueryHookResult = ReturnType<
  typeof useListVehicleTypesLazyQuery
>
export const IsNeedAccessRemarkDocument = gql`
  query isNeedAccessRemark($id: String!, $type: AccessType!) {
    vehicles {
      isNeedAccessRemark(id: $id, type: $type)
    }
  }
`

/**
 * __useIsNeedAccessRemarkQuery__
 *
 * To run a query within a React component, call `useIsNeedAccessRemarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsNeedAccessRemarkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsNeedAccessRemarkQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useIsNeedAccessRemarkQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsNeedAccessRemarkQuery,
    IsNeedAccessRemarkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IsNeedAccessRemarkQuery,
    IsNeedAccessRemarkQueryVariables
  >(IsNeedAccessRemarkDocument, options)
}
export function useIsNeedAccessRemarkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsNeedAccessRemarkQuery,
    IsNeedAccessRemarkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IsNeedAccessRemarkQuery,
    IsNeedAccessRemarkQueryVariables
  >(IsNeedAccessRemarkDocument, options)
}
export type IsNeedAccessRemarkQueryHookResult = ReturnType<
  typeof useIsNeedAccessRemarkQuery
>
export type IsNeedAccessRemarkLazyQueryHookResult = ReturnType<
  typeof useIsNeedAccessRemarkLazyQuery
>
export const ListAccessHistoryDocument = gql`
  query listAccessHistory($param: AccessHistoryParam) {
    vehicles {
      listAccessHistory(param: $param) {
        data {
          vinNo
          imei
          user
          remark
          date
          type
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
        lastUpdated
      }
    }
  }
`

/**
 * __useListAccessHistoryQuery__
 *
 * To run a query within a React component, call `useListAccessHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccessHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccessHistoryQuery({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useListAccessHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListAccessHistoryQuery,
    ListAccessHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListAccessHistoryQuery,
    ListAccessHistoryQueryVariables
  >(ListAccessHistoryDocument, options)
}
export function useListAccessHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAccessHistoryQuery,
    ListAccessHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListAccessHistoryQuery,
    ListAccessHistoryQueryVariables
  >(ListAccessHistoryDocument, options)
}
export type ListAccessHistoryQueryHookResult = ReturnType<
  typeof useListAccessHistoryQuery
>
export type ListAccessHistoryLazyQueryHookResult = ReturnType<
  typeof useListAccessHistoryLazyQuery
>
export const GroupReportMonthDocument = gql`
  query GroupReportMonth($param: HistoryParam, $pagination: PaginationParam) {
    vehicles {
      GetGroupReport(param: $param, pagination: $pagination) {
        data {
          avgDistancePerDay
          avgDistancePerTrip
          avgDurationPerDay
          avgDurationPerTrip
          avgSpeed
          avgTripPerDay
          avgBatteryPerDay
          avgBatteryPerTrip
          distance
          duration
          topSpeed
          tripCount
          FleetName
          LicensePlate
          Status
          batteryConsumption
          firstTripStartTime
          lastTripEndTime
          vinNo
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useGroupReportMonthQuery__
 *
 * To run a query within a React component, call `useGroupReportMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupReportMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupReportMonthQuery({
 *   variables: {
 *      param: // value for 'param'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGroupReportMonthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GroupReportMonthQuery,
    GroupReportMonthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GroupReportMonthQuery, GroupReportMonthQueryVariables>(
    GroupReportMonthDocument,
    options
  )
}
export function useGroupReportMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupReportMonthQuery,
    GroupReportMonthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GroupReportMonthQuery,
    GroupReportMonthQueryVariables
  >(GroupReportMonthDocument, options)
}
export type GroupReportMonthQueryHookResult = ReturnType<
  typeof useGroupReportMonthQuery
>
export type GroupReportMonthLazyQueryHookResult = ReturnType<
  typeof useGroupReportMonthLazyQuery
>
export const GroupReportDetailDocument = gql`
  query GroupReportDetail($param: HistoryParam, $pagination: PaginationParam) {
    vehicles {
      GetGroupReportDetail(param: $param, pagination: $pagination) {
        data {
          FleetName
          LicensePlate
          startTime
          endTime
          batteryConsumption
          avgSpeed
          topSpeed
          duration
          distance
          vinNo
        }
        pagination {
          first
          before
          current
          next
          last
          perPage
          totalPage
          totalRecord
        }
      }
    }
  }
`

/**
 * __useGroupReportDetailQuery__
 *
 * To run a query within a React component, call `useGroupReportDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupReportDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupReportDetailQuery({
 *   variables: {
 *      param: // value for 'param'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGroupReportDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GroupReportDetailQuery,
    GroupReportDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GroupReportDetailQuery,
    GroupReportDetailQueryVariables
  >(GroupReportDetailDocument, options)
}
export function useGroupReportDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupReportDetailQuery,
    GroupReportDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GroupReportDetailQuery,
    GroupReportDetailQueryVariables
  >(GroupReportDetailDocument, options)
}
export type GroupReportDetailQueryHookResult = ReturnType<
  typeof useGroupReportDetailQuery
>
export type GroupReportDetailLazyQueryHookResult = ReturnType<
  typeof useGroupReportDetailLazyQuery
>
export const GetPublicTrackingDocument = gql`
  query GetPublicTracking($id: String!) {
    vehicles {
      GetPublicTracking(id: $id) {
        ID
        data {
          vehicle {
            ID
            active
            deviceID
            fleetModels
            fleetModelsID
            fleetName
            fleetType
            fleetTypeID
            licensePlate
            properties {
              field
              value
            }
            status
            tags {
              field
              value
            }
            tenantID
            vinNO
            imei
            deviceModel
            deviceModelID
            image
            remark
          }
          position {
            altitude
            course
            deviceTime
            ignition
            latitude
            longitude
            movement
            positioningTime
            properties {
              field
              value
            }
            serverTime
            speed
            imei
            status
            sim
            battery
            mcb
            address
            place
            remarks
            event
            mileage
          }
        }
      }
    }
  }
`

/**
 * __useGetPublicTrackingQuery__
 *
 * To run a query within a React component, call `useGetPublicTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicTrackingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublicTrackingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicTrackingQuery,
    GetPublicTrackingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPublicTrackingQuery,
    GetPublicTrackingQueryVariables
  >(GetPublicTrackingDocument, options)
}
export function useGetPublicTrackingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicTrackingQuery,
    GetPublicTrackingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPublicTrackingQuery,
    GetPublicTrackingQueryVariables
  >(GetPublicTrackingDocument, options)
}
export type GetPublicTrackingQueryHookResult = ReturnType<
  typeof useGetPublicTrackingQuery
>
export type GetPublicTrackingLazyQueryHookResult = ReturnType<
  typeof useGetPublicTrackingLazyQuery
>
export const CreatePublicTrackingDocument = gql`
  mutation CreatePublicTracking($vin: String!) {
    vehicles {
      CreatePublicTracking(vin: $vin) {
        id
        success
        message
      }
    }
  }
`

/**
 * __useCreatePublicTrackingMutation__
 *
 * To run a mutation, you first call `useCreatePublicTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicTrackingMutation, { data, loading, error }] = useCreatePublicTrackingMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useCreatePublicTrackingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePublicTrackingMutation,
    CreatePublicTrackingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePublicTrackingMutation,
    CreatePublicTrackingMutationVariables
  >(CreatePublicTrackingDocument, options)
}
export type CreatePublicTrackingMutationHookResult = ReturnType<
  typeof useCreatePublicTrackingMutation
>
export const CreateVehiclesAccessHistoryDocument = gql`
  mutation createVehiclesAccessHistory(
    $id: String!
    $remark: String!
    $type: AccessType!
  ) {
    vehicles {
      createVehicleAccessHistory(id: $id, remark: $remark, type: $type) {
        id
        message
        success
      }
    }
  }
`

/**
 * __useCreateVehiclesAccessHistoryMutation__
 *
 * To run a mutation, you first call `useCreateVehiclesAccessHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehiclesAccessHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehiclesAccessHistoryMutation, { data, loading, error }] = useCreateVehiclesAccessHistoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      remark: // value for 'remark'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateVehiclesAccessHistoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVehiclesAccessHistoryMutation,
    CreateVehiclesAccessHistoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateVehiclesAccessHistoryMutation,
    CreateVehiclesAccessHistoryMutationVariables
  >(CreateVehiclesAccessHistoryDocument, options)
}
export type CreateVehiclesAccessHistoryMutationHookResult = ReturnType<
  typeof useCreateVehiclesAccessHistoryMutation
>
export const VehicleSingleUploadDocument = gql`
  mutation vehicleSingleUpload($in: Upload!) {
    vehicles {
      singleUpload(in: $in) {
        success
        message
        name
      }
    }
  }
`

/**
 * __useVehicleSingleUploadMutation__
 *
 * To run a mutation, you first call `useVehicleSingleUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVehicleSingleUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vehicleSingleUploadMutation, { data, loading, error }] = useVehicleSingleUploadMutation({
 *   variables: {
 *      in: // value for 'in'
 *   },
 * });
 */
export function useVehicleSingleUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VehicleSingleUploadMutation,
    VehicleSingleUploadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VehicleSingleUploadMutation,
    VehicleSingleUploadMutationVariables
  >(VehicleSingleUploadDocument, options)
}
export type VehicleSingleUploadMutationHookResult = ReturnType<
  typeof useVehicleSingleUploadMutation
>
export const CreateVehiclesDocument = gql`
  mutation createVehicles($param: VehicleParam!) {
    vehicles {
      createVehicles(param: $param) {
        message
        success
      }
    }
  }
`

/**
 * __useCreateVehiclesMutation__
 *
 * To run a mutation, you first call `useCreateVehiclesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehiclesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehiclesMutation, { data, loading, error }] = useCreateVehiclesMutation({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useCreateVehiclesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVehiclesMutation,
    CreateVehiclesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateVehiclesMutation,
    CreateVehiclesMutationVariables
  >(CreateVehiclesDocument, options)
}
export type CreateVehiclesMutationHookResult = ReturnType<
  typeof useCreateVehiclesMutation
>
export const UpdateVehiclesDocument = gql`
  mutation updateVehicles($id: String!, $param: VehicleParam!) {
    vehicles {
      updateVehicles(id: $id, param: $param) {
        message
        success
      }
    }
  }
`

/**
 * __useUpdateVehiclesMutation__
 *
 * To run a mutation, you first call `useUpdateVehiclesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehiclesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehiclesMutation, { data, loading, error }] = useUpdateVehiclesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      param: // value for 'param'
 *   },
 * });
 */
export function useUpdateVehiclesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVehiclesMutation,
    UpdateVehiclesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateVehiclesMutation,
    UpdateVehiclesMutationVariables
  >(UpdateVehiclesDocument, options)
}
export type UpdateVehiclesMutationHookResult = ReturnType<
  typeof useUpdateVehiclesMutation
>
export const DeleteVehiclesDocument = gql`
  mutation deleteVehicles($id: String!) {
    vehicles {
      deleteVehicles(id: $id) {
        message
        success
      }
    }
  }
`

/**
 * __useDeleteVehiclesMutation__
 *
 * To run a mutation, you first call `useDeleteVehiclesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehiclesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehiclesMutation, { data, loading, error }] = useDeleteVehiclesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehiclesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVehiclesMutation,
    DeleteVehiclesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteVehiclesMutation,
    DeleteVehiclesMutationVariables
  >(DeleteVehiclesDocument, options)
}
export type DeleteVehiclesMutationHookResult = ReturnType<
  typeof useDeleteVehiclesMutation
>
export const AddVehicleToGroupDocument = gql`
  mutation addVehicleToGroup($id: String!, $orgid: String!) {
    vehicles {
      addVehicleToGroup(id: $id, orgid: $orgid) {
        message
        success
      }
    }
  }
`

/**
 * __useAddVehicleToGroupMutation__
 *
 * To run a mutation, you first call `useAddVehicleToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVehicleToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVehicleToGroupMutation, { data, loading, error }] = useAddVehicleToGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orgid: // value for 'orgid'
 *   },
 * });
 */
export function useAddVehicleToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddVehicleToGroupMutation,
    AddVehicleToGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AddVehicleToGroupMutation,
    AddVehicleToGroupMutationVariables
  >(AddVehicleToGroupDocument, options)
}
export type AddVehicleToGroupMutationHookResult = ReturnType<
  typeof useAddVehicleToGroupMutation
>
export const BulkAddVehicleToGroupDocument = gql`
  mutation bulkAddVehicleToGroup($ids: String!, $orgid: String!) {
    vehicles {
      bulkAddVehicleToGroup(ids: $ids, orgid: $orgid) {
        message
        success
      }
    }
  }
`

/**
 * __useBulkAddVehicleToGroupMutation__
 *
 * To run a mutation, you first call `useBulkAddVehicleToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddVehicleToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddVehicleToGroupMutation, { data, loading, error }] = useBulkAddVehicleToGroupMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      orgid: // value for 'orgid'
 *   },
 * });
 */
export function useBulkAddVehicleToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkAddVehicleToGroupMutation,
    BulkAddVehicleToGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkAddVehicleToGroupMutation,
    BulkAddVehicleToGroupMutationVariables
  >(BulkAddVehicleToGroupDocument, options)
}
export type BulkAddVehicleToGroupMutationHookResult = ReturnType<
  typeof useBulkAddVehicleToGroupMutation
>
export const CreateWebHookUrlDocument = gql`
  mutation createWebHookUrl($data: WebhookURLInput!, $orgID: String!) {
    geofences {
      CreateWebhookURL(data: $data, orgID: $orgID) {
        success
        message
        id
      }
    }
  }
`

/**
 * __useCreateWebHookUrlMutation__
 *
 * To run a mutation, you first call `useCreateWebHookUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebHookUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebHookUrlMutation, { data, loading, error }] = useCreateWebHookUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *      orgID: // value for 'orgID'
 *   },
 * });
 */
export function useCreateWebHookUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWebHookUrlMutation,
    CreateWebHookUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateWebHookUrlMutation,
    CreateWebHookUrlMutationVariables
  >(CreateWebHookUrlDocument, options)
}
export type CreateWebHookUrlMutationHookResult = ReturnType<
  typeof useCreateWebHookUrlMutation
>
export const EditWebHookUrlDocument = gql`
  mutation editWebHookUrl($data: WebhookURLInput!, $id: String!) {
    geofences {
      EditWebhookURL(data: $data, id: $id) {
        success
        message
        id
      }
    }
  }
`

/**
 * __useEditWebHookUrlMutation__
 *
 * To run a mutation, you first call `useEditWebHookUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWebHookUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWebHookUrlMutation, { data, loading, error }] = useEditWebHookUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditWebHookUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditWebHookUrlMutation,
    EditWebHookUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    EditWebHookUrlMutation,
    EditWebHookUrlMutationVariables
  >(EditWebHookUrlDocument, options)
}
export type EditWebHookUrlMutationHookResult = ReturnType<
  typeof useEditWebHookUrlMutation
>
export const DeleteWebHookUrlDocument = gql`
  mutation deleteWebHookUrl($id: String!) {
    geofences {
      DeleteWebhookURL(id: $id) {
        success
        message
        id
      }
    }
  }
`

/**
 * __useDeleteWebHookUrlMutation__
 *
 * To run a mutation, you first call `useDeleteWebHookUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebHookUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebHookUrlMutation, { data, loading, error }] = useDeleteWebHookUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWebHookUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWebHookUrlMutation,
    DeleteWebHookUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteWebHookUrlMutation,
    DeleteWebHookUrlMutationVariables
  >(DeleteWebHookUrlDocument, options)
}
export type DeleteWebHookUrlMutationHookResult = ReturnType<
  typeof useDeleteWebHookUrlMutation
>
export const UploadVehicleImageDocument = gql`
  mutation uploadVehicleImage($in: Upload!, $id: String!) {
    vehicles {
      UploadVehicleImage(in: $in, id: $id) {
        message
        success
        name
      }
    }
  }
`

/**
 * __useUploadVehicleImageMutation__
 *
 * To run a mutation, you first call `useUploadVehicleImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVehicleImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVehicleImageMutation, { data, loading, error }] = useUploadVehicleImageMutation({
 *   variables: {
 *      in: // value for 'in'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUploadVehicleImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadVehicleImageMutation,
    UploadVehicleImageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadVehicleImageMutation,
    UploadVehicleImageMutationVariables
  >(UploadVehicleImageDocument, options)
}
export type UploadVehicleImageMutationHookResult = ReturnType<
  typeof useUploadVehicleImageMutation
>
export const GetVehicleStatusSummaryDocument = gql`
  query GetVehicleStatusSummary {
    vehicles {
      GetVehicleStatusSummary {
        lastUpdated
        vehicleStatusSummary {
          totalUnits
          noRfidDriver
          unregisteredRfid
          noGpsData
        }
        engineStatus {
          on
          off
          delay
        }
        inArea {
          private
          public
        }
        vehicleStatus {
          driving
          stop
          idle
          delay
        }
      }
    }
  }
`

/**
 * __useGetVehicleStatusSummaryQuery__
 *
 * To run a query within a React component, call `useGetVehicleStatusSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleStatusSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleStatusSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVehicleStatusSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetVehicleStatusSummaryQuery,
    GetVehicleStatusSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetVehicleStatusSummaryQuery,
    GetVehicleStatusSummaryQueryVariables
  >(GetVehicleStatusSummaryDocument, options)
}
export function useGetVehicleStatusSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVehicleStatusSummaryQuery,
    GetVehicleStatusSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetVehicleStatusSummaryQuery,
    GetVehicleStatusSummaryQueryVariables
  >(GetVehicleStatusSummaryDocument, options)
}
export type GetVehicleStatusSummaryQueryHookResult = ReturnType<
  typeof useGetVehicleStatusSummaryQuery
>
export type GetVehicleStatusSummaryLazyQueryHookResult = ReturnType<
  typeof useGetVehicleStatusSummaryLazyQuery
>
export const GetBiReportsDocument = gql`
  query getBIReports {
    vehicles {
      GetBIReports {
        reports {
          name
          reportUrl
          permissions
          url
        }
      }
    }
  }
`

/**
 * __useGetBiReportsQuery__
 *
 * To run a query within a React component, call `useGetBiReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBiReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBiReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBiReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBiReportsQuery,
    GetBiReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBiReportsQuery, GetBiReportsQueryVariables>(
    GetBiReportsDocument,
    options
  )
}
export function useGetBiReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBiReportsQuery,
    GetBiReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetBiReportsQuery, GetBiReportsQueryVariables>(
    GetBiReportsDocument,
    options
  )
}
export type GetBiReportsQueryHookResult = ReturnType<
  typeof useGetBiReportsQuery
>
export type GetBiReportsLazyQueryHookResult = ReturnType<
  typeof useGetBiReportsLazyQuery
>
export const AvailableKalistaMerchantDocument = gql`
  query availableKalistaMerchant {
    vehicles {
      AvailableKalistaMerchants {
        code
        label
        permission
      }
    }
  }
`

/**
 * __useAvailableKalistaMerchantQuery__
 *
 * To run a query within a React component, call `useAvailableKalistaMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableKalistaMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableKalistaMerchantQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableKalistaMerchantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableKalistaMerchantQuery,
    AvailableKalistaMerchantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AvailableKalistaMerchantQuery,
    AvailableKalistaMerchantQueryVariables
  >(AvailableKalistaMerchantDocument, options)
}
export function useAvailableKalistaMerchantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableKalistaMerchantQuery,
    AvailableKalistaMerchantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AvailableKalistaMerchantQuery,
    AvailableKalistaMerchantQueryVariables
  >(AvailableKalistaMerchantDocument, options)
}
export type AvailableKalistaMerchantQueryHookResult = ReturnType<
  typeof useAvailableKalistaMerchantQuery
>
export type AvailableKalistaMerchantLazyQueryHookResult = ReturnType<
  typeof useAvailableKalistaMerchantLazyQuery
>
export const DetachGrabDocument = gql`
  mutation detachGrab($vin: String!) {
    grab {
      detachGrab(vin: $vin) {
        id
        message
        success
      }
    }
  }
`

/**
 * __useDetachGrabMutation__
 *
 * To run a mutation, you first call `useDetachGrabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachGrabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachGrabMutation, { data, loading, error }] = useDetachGrabMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useDetachGrabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DetachGrabMutation,
    DetachGrabMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DetachGrabMutation, DetachGrabMutationVariables>(
    DetachGrabDocument,
    options
  )
}
export type DetachGrabMutationHookResult = ReturnType<
  typeof useDetachGrabMutation
>
export const DetailVehicleDetachGrabDocument = gql`
  query detailVehicleDetachGrab($id: String!) {
    vehicles {
      lastPosition(id: $id) {
        data {
          canDetachGrab
        }
      }
    }
  }
`

/**
 * __useDetailVehicleDetachGrabQuery__
 *
 * To run a query within a React component, call `useDetailVehicleDetachGrabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailVehicleDetachGrabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailVehicleDetachGrabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailVehicleDetachGrabQuery(
  baseOptions: Apollo.QueryHookOptions<
    DetailVehicleDetachGrabQuery,
    DetailVehicleDetachGrabQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DetailVehicleDetachGrabQuery,
    DetailVehicleDetachGrabQueryVariables
  >(DetailVehicleDetachGrabDocument, options)
}
export function useDetailVehicleDetachGrabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DetailVehicleDetachGrabQuery,
    DetailVehicleDetachGrabQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DetailVehicleDetachGrabQuery,
    DetailVehicleDetachGrabQueryVariables
  >(DetailVehicleDetachGrabDocument, options)
}
export type DetailVehicleDetachGrabQueryHookResult = ReturnType<
  typeof useDetailVehicleDetachGrabQuery
>
export type DetailVehicleDetachGrabLazyQueryHookResult = ReturnType<
  typeof useDetailVehicleDetachGrabLazyQuery
>
